import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_miezz_common_history = _resolveComponent("miezz-common-history")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_page_list, {
      ref: "page-list",
      modelValue: _ctx.list,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list) = $event)),
      onHandleGet: _ctx.handleGet,
      onHandleBottomButtonClick: _ctx.handleBottomButtonClick,
      onHandleRowButtonClick: _ctx.handleRowButtonClick
    }, null, 8, ["modelValue", "onHandleGet", "onHandleBottomButtonClick", "onHandleRowButtonClick"]),
    _createVNode(_component_miezz_modal, {
      modelValue: _ctx.modalHistories,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalHistories) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_common_history, {
          modelValue: _ctx.histories,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.histories) = $event)),
          "label-width": "190px"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}